import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../brand/Logo';
import { Seal } from '../brand/Seal';
import { programs } from '../../data/programs';
import { products } from '../../data/products';
import { useBrand } from '../../contexts/BrandContext';
import { navItems } from '../../data/site';
export function Footer() {
  const {
    brand,
    text
  } = useBrand();
  return <footer className="border-t border-ink/10 bg-cream-deep text-ink" data-id="element-144" data-mp="npt8eauc8ux">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-20" data-id="element-145" data-mp="q2kji2hnvkn">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_1fr_1fr_1fr_1fr]" data-id="element-146" data-mp="3s13z01bumkx4">
          <div data-id="element-147" data-mp="3n2srvycxuoil">
            <Logo className="text-lg" data-id="element-148" data-mp="3n4dm1mvcc5fx" />
            <p className="mt-6 max-w-xs font-serif text-2xl leading-snug text-ink" data-id="element-149" data-mp="3n17rvt7uuddc">
              {brand.copy.manifesto}
            </p>
            <Seal className="mt-10 h-24 w-24 text-brick/60" data-id="element-150" data-mp="3e35nr4str4lu" />
          </div>

          <FooterColumn title="Programs" data-id="element-151" data-mp="3942sgc2nccr2">
            {programs.slice(0, 5).map(program => <FooterLink key={program.slug} to={`/programs/${program.slug}`} data-id="element-152" data-mp="2kdd1srlouxq5">
                {program.name}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title="Pharmacy" data-id="element-153" data-mp="2p5xol966gak6">
            {products.slice(0, 5).map(product => <FooterLink key={product.slug} to={`/shop/${product.slug}`} data-id="element-154" data-mp="2babxmwgdvgp4">
                {product.name}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title={brand.name} data-id="element-155" data-mp="341lsex7l2vnj">
            {navItems.map(item => <FooterLink key={item.to} to={item.to} data-id="element-156" data-mp="381nw1bwvpz5g">
                {item.label}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title="Patients" data-id="element-157" data-mp="2u5ab1st4zfm8">
            <FooterLink to="/get-started" data-id="element-158" data-mp="2z0y2kev3ckuw">Start intake</FooterLink>
            <FooterLink to="/labs" data-id="element-159" data-mp="1inr7fzbn9an5">Book a lab draw</FooterLink>
            <FooterLink to="/pricing" data-id="element-160" data-mp="1imfzdnb61gq8">Membership pricing</FooterLink>
            <FooterLink to="/about" data-id="element-161" data-mp="1nnvl7hl63r9o">Clinical standards</FooterLink>
          </FooterColumn>
        </div>

        <div className="rule-light mt-16 pt-8" data-id="element-162" data-mp="13joeqxm90fb2">
          <p className="max-w-4xl text-xs leading-relaxed text-ink-muted" data-id="element-163" data-mp="13mkdup9u1a13">
            {text('Republic is a direct-pay clinical practice. Treatment is prescribed only where clinically appropriate following review by a licensed clinician. Compounded medications are not FDA-approved products and are dispensed by US-licensed 503A and 503B pharmacies. This site is for informational purposes and is not a substitute for individual medical advice.')}
          </p>
          <div className="mt-8 flex flex-col gap-4 text-xs text-ink-muted sm:flex-row sm:items-center sm:justify-between" data-id="element-164" data-mp="fxhv1e3gpb50">
            <p data-id="element-165" data-mp="6uqh97n463a7">
              © {new Date().getFullYear()} {brand.copy.legalName}
            </p>
            <div className="flex gap-6" data-id="element-166" data-mp="267b0hohlzu0j">
              <Link to="/about" className="hover:text-brick" data-id="element-167" data-mp="2669mpc97ktf4">
                Privacy
              </Link>
              <Link to="/about" className="hover:text-brick" data-id="element-168" data-mp="21914xcrz2ree">
                Terms
              </Link>
              <Link to="/about" className="hover:text-brick" data-id="element-169" data-mp="28rqx5rink5qh">
                HIPAA notice
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}
function FooterColumn({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-170" data-mp="2ngdneo9tihwh">
      <h2 className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-171" data-mp="2ng3tiplnjqli">{title}</h2>
      <ul className="mt-6 flex flex-col gap-3" data-id="element-172" data-mp="1puponwpw3nhs">{children}</ul>
    </div>;
}
function FooterLink({
  to,
  children
}: {
  to: string;
  children: React.ReactNode;
}) {
  return <li data-id="element-173" data-mp="1zr2s3mb8lfpq">
      <Link to={to} className="text-sm text-ink-soft transition-colors duration-150 ease-republic hover:text-brick" data-id="element-174" data-mp="1zq9h2958w41s">
        {children}
      </Link>
    </li>;
}